import firebase from "./firebase";

const firebaseDb = firebase.database();
const firebaseAuth = firebase.auth();
const firebaseFirestore = firebase.firestore();
const firebaseStorage = firebase.storage();
export { firebaseDb, firebaseAuth, firebaseFirestore, firebaseStorage };
